import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { CGUID, SyncSeekUrl, SyncPullSerializedUrl,GetDatasyncMediaOneBlockSynchronously,SyncDeleteSynchronously} from "datasync-core";
import { globals} from "../Components/Globals/Globals";
import { produce } from 'immer';
const initialState = {
  articlesItems: [],
  articleCount: 0,
  loadArticles_result:{status: 'idle', error: null},
  deleteArticle_result:{status: 'idle', error: null},
  validateArticles_result:{status: 'idle', error: null, stat_email:null, stat_action:null},
}

// Create an async thunk for loading articles
export const loadArticles = createAsyncThunk(
  'articles/loadArticles',
  async (thunkAPI) => {
    try {
      const response = await GetDatasyncMediaOneBlockSynchronously({
        session_guid: CGUID(),
        date_synchro: '1970-07-10 063050',
        company_guid: globals.datasync.platform_company_guid,
        datasync_url: globals.datasync_service.url,
        syncSeekUrl: SyncSeekUrl(globals.datasync_service.url),
        SyncPullSerializedGETurl: SyncPullSerializedUrl(globals.datasync_service.url),
        seek_filter_clause: ` true `, // Do not filter articles
        table_guid: globals.datasync.pf_articles_table_guid,
        debugging: true
      });
      if (globals.parameters.debugging)
        console.log("loadArticles::articles response = ",response)
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Create an async thunk for deleting articles
export const deleteArticle = createAsyncThunk(
  'articles/deleteArticle',
  async (deletedArticleObject) => {
    try {
      console.clear()
      console.log("deletedArticleObject->", deletedArticleObject)
      //Delete article from Remote Datasync Database
      const response = await SyncDeleteSynchronously({
        datasync_url:globals.datasync_service.url,
        data_guid: deletedArticleObject.data_guid});
      
      if (globals.parameters.debugging)
        console.log("deleteArticle->response = ",response)

      if (response.err || response.deleted_data_count !=1)
        throw(response.err)

      return response;
    } catch (error) {
      return deletedArticleObject.rejectWithValue(error.message);
    }
  }
);

const articleSlice = createSlice({
  name: 'articles',
  initialState,
  reducers: {
    addArticle(state, action) {
      // New stat added 
      try {
        if (globals.parameters.debugging){
          console.log("addArticle: ", state.articlesItems)
          console.log("addArticle: ", state.articleCount)
          console.log("addArticle::action ->", action)  
        }
  
        state.articleCount++;
        state.articlesItems.push(action.payload);
      } catch (error) {
        console.error("Article added but state list insertion fails !")
        alert("Echec de l'insertion du nouvel utilisateur en mémoire interne")
      }
    },

    updateArticle(state, action) {
      return produce(state, draft => {
        //Find former stat object to update
        const updatedArticleObject = draft.articlesItems.find((article) => article.data_guid === action.payload.data_guid)
        console.log("updateArticle: updatedArticleObject->", updatedArticleObject)
        if (updatedArticleObject) {
          //update article in the array
          updatedArticleObject.data_blob.data_tier = action.payload.data_blob.data_tier;
        } else {
          console.error("updateArticle: Article not found in the array");
        }
      })
    },

    revertAllArticles(state){
      console.log("articleSlice revertAllArticles");
      state.articlesItems = [];
      state.articleCount = 0;
      state.loadArticles_result = {status: 'idle', error: null};
      state.deleteArticle_result = {status: 'idle', error: null};
      state.validateArticles_result = {status: 'idle', error: null, stat_email:null, stat_action:null};
    },

    revertStatusArticles(state){
      if (globals.parameters.debugging)
        console.log("revertStatusArticles")

      state.deleteArticle_result = {status: 'idle', error: null};
      state.validateArticles_result = {status: 'idle', error: null, stat_email:null, stat_action:null};
    }
  },
  extraReducers: (builder) => {
    builder
      /* loadArticles */
      .addCase(loadArticles.pending, (state, action) => {
        state.loadArticles_result = {status : "loading",error : null};
      })
      .addCase(loadArticles.fulfilled, (state, action) => {
        if (action.payload.length > 0) {
          state.loadArticles_result = {status : "succeeded",error : null};
          state.articlesItems = action.payload;
          state.articleCount= action.payload.length;
        }
        else {
          state.loadArticles_result = {status : "succeeded",error : "No articles found !!!"};
          state.articlesItems = [];
          state.articleCount= 0;
        }
      })
      .addCase(loadArticles.rejected, (state, action) => {
        state.loadArticles_result = {status : "failed",error : action.payload};
      })

      /* deleteArticle */
      .addCase(deleteArticle.pending, (state,action) => {
        if (globals.parameters.redux_debugging) alert("deleteArticle.pending")
        console.log("deleteArticle.pending -> action", action)
        state.deleteArticle_result = {status : "deleting",error : null};
      })
      .addCase(deleteArticle.fulfilled, (state,action) => {
        //Article sucessfully deleted from syncDeleteAsynchronous process
        if (globals.parameters.redux_debugging) alert("deleteArticle.fulfilled")
        console.log("deleteArticle.fulfilled -> action", action, " state->", state)

        return produce(state, draft => {
          //Delete article from local state
          draft.articlesItems = draft.articlesItems.filter((article, j) => article.data_guid !== action.payload.data_guid)
          draft.articleCount--;

          draft.deleteArticle_result = {status : "deleted",error : null};
        })
      })
      .addCase(deleteArticle.rejected, (state,action) => {
        if (globals.parameters.redux_debugging) alert("deleteArticle.rejected")
          console.log("deleteArticle.rejected -> action", action)
        state.deleteArticle_result = {status : "failed",error : action.payload};
      })
  },
});

export const { addArticle, updateArticle, revertAllArticles, revertStatusArticles } = articleSlice.actions;
export default articleSlice.reducer;